import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import Immutable from 'immutable';
import { workingStart, workingEnd, startInterdiction } from 'wfui-digital-core/es/actions';
import { updateForm, updateField, clearFieldMessages } from 'wfui-digital-core/es/wf-form-api';
import { WF_FORM_SUBMIT } from '../store/wf-form/actions';
import post from '../network/post';
import transformFormData from './support/transform-form-data';
import transformMessages from './support/transform-messages';
import transformFieldMessages from './support/transform-field-messages';

var submitForm = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var formState, dispatch, reduxDispatch, _ref$showWorkingIndic, showWorkingIndicator, result, formId, action, fields, _formState$transform, transform, postData, _formState$postOption, postOptions, data, response, messages, FailureMessageBean, InterdictionViewBean, _messages;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formState = _ref.formState, dispatch = _ref.dispatch, reduxDispatch = _ref.reduxDispatch, _ref$showWorkingIndic = _ref.showWorkingIndicator, showWorkingIndicator = _ref$showWorkingIndic === void 0 ? true : _ref$showWorkingIndic;
            formId = formState.formId, action = formState.action, fields = formState.fields, _formState$transform = formState.transform, transform = _formState$transform === void 0 ? function (fields) {
              return fields;
            } : _formState$transform, postData = formState.postData, _formState$postOption = formState.postOptions, postOptions = _formState$postOption === void 0 ? {} : _formState$postOption; // Turn the form state into an object of key value pairs to submit to the server

            data = transformFormData({
              fields: fields,
              transform: transform
            }); // Put the form into 'submitting' state

            dispatch(updateForm({
              formId: formId,
              submitting: true,
              messages: Immutable.List()
            })); // Clear all field messages

            dispatch(clearFieldMessages({
              formId: formId
            })); // Show the working indicator

            showWorkingIndicator && reduxDispatch(workingStart());
            _context.prev = 6;
            _context.next = 9;
            return post(Object.assign({}, postOptions, {
              url: action,
              data: data,
              postData: postData
            }));

          case 9:
            response = _context.sent;
            _context.next = 12;
            return response.SuccessMessageBean;

          case 12:
            if (!_context.sent) {
              _context.next = 16;
              break;
            }

            _context.t0 = transformMessages(response.SuccessMessageBean.globalMessages);
            _context.next = 17;
            break;

          case 16:
            _context.t0 = [];

          case 17:
            messages = _context.t0;
            // Take the form out of 'submitting' state and apply messages
            dispatch(updateForm({
              formId: formId,
              submitting: false,
              messages: messages
            }));
            result = Promise.resolve(response);
            _context.next = 26;
            break;

          case 22:
            _context.prev = 22;
            _context.t1 = _context["catch"](6);
            FailureMessageBean = _context.t1.FailureMessageBean, InterdictionViewBean = _context.t1.InterdictionViewBean;

            if (FailureMessageBean) {
              _messages = transformMessages(FailureMessageBean.globalMessages);
              dispatch(updateForm({
                formId: formId,
                submitting: false,
                messages: _messages
              }));
              transformFieldMessages({
                fields: fields,
                messages: FailureMessageBean.fieldMessages
              }).filter(function (_ref3) {
                var fieldId = _ref3.fieldId;
                return formState.fields.get(fieldId);
              }).forEach(function (_ref4) {
                var fieldId = _ref4.fieldId,
                    message = _ref4.message;
                return dispatch(updateField({
                  formId: formId,
                  fieldId: fieldId,
                  message: message,
                  showMessage: true
                }));
              });
              result = Promise.reject(_context.t1);
            } else if (InterdictionViewBean) {
              dispatch(updateForm({
                formId: formId,
                submitting: false
              }));
              reduxDispatch(startInterdiction({
                interdiction: InterdictionViewBean,
                postSuccessAction: WF_FORM_SUBMIT,
                postSuccessPayload: {
                  formState: formState,
                  dispatch: dispatch,
                  reduxDispatch: reduxDispatch,
                  showWorkingIndicator: showWorkingIndicator
                }
              }));
            }

          case 26:
            _context.prev = 26;
            showWorkingIndicator && reduxDispatch(workingEnd());
            return _context.finish(26);

          case 29:
            return _context.abrupt("return", result);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 22, 26, 29]]);
  }));

  return function submitForm(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default submitForm;